import React from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { Grid } from '@mui/material'
import { setEnrollDetail } from 'src/redux/slices/eLearning/enroll'
import DatePicker from 'src/components/DatePicker'
import { getError } from './event'

const DateSelect = ({ index, obj, label, disabled, required = true }) => {
  const dispatch = useDispatch()
  const { value, formError, showFormError } = useSelector(
    (state) => ({
      value: state.eLearningEnroll.body.enroll[index][obj],
      formError: state.eLearningEnroll.formError[index],
      showFormError: state.eLearningEnroll.showFormError,
    }),
    shallowEqual
  )
  return (
    <Grid item sm={4} xs={12}>
      <DatePicker
        id={`${obj}-${index}`}
        labelText={label}
        value={value || null}
        required={required}
        placeholder="กรุณาเลือก"
        hideTextError={!showFormError}
        textError={getError(formError, obj)}
        boxSx={{
          '& .MuiTextField-root': {
            background: '#FFFFFF',
            '& input.Mui-disabled': {
              WebkitTextFillColor: 'rgba(0, 0, 0, 0.70)',
            },
            '& svg': {
              color: '#00008F',
            },
          },
        }}
        onChange={(e) => {
          dispatch(
            setEnrollDetail({
              key: 'enroll',
              index,
              obj,
              value: e || '',
            })
          )
        }}
        disabledInput={disabled}
      />
    </Grid>
  )
}

export default DateSelect
